/**
 * Custom Expired Date Sorting for Collection Page
 * Handles sorting products by their wk_custom_field.cus_expiry_date metafield
 */

(function () {
  "use strict";

  // Store original order of products
  let originalProductOrder = [];
  let isCustomSortActive = false;

  /**
   * Initialize the expired date sorting functionality
   */
  function initExpiredDateSort() {
    const sortSelect = document.querySelector(
      "[data-productgrid-trigger-sort]",
    );
    const sortButtons = document.querySelectorAll(
      '[data-productgrid-trigger-sort-button][data-custom-sort="true"]',
    );

    // Store original product order on page load
    storeOriginalOrder();

    // Handle select dropdown change
    if (sortSelect) {
      sortSelect.addEventListener("change", function (e) {
        const selectedValue = e.target.value;
        handleSortChange(selectedValue);
      });
    }

    // Handle modal button clicks for custom sort options
    sortButtons.forEach(function (button) {
      button.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        const sortValue = this.getAttribute("value");
        handleCustomSort(sortValue);

        // Update select dropdown to match
        if (sortSelect) {
          sortSelect.value = sortValue;
        }

        // Close modal if exists
        const modal = document.querySelector("[data-productgrid-sort-content]");
        if (modal) {
          modal.setAttribute("aria-hidden", "true");
        }

        // Update active state on buttons
        updateActiveButtonState(sortValue);
      });
    });
  }

  /**
   * Store the original order of products
   */
  function storeOriginalOrder() {
    const container = document.querySelector("[data-productgrid-items]");
    if (!container) return;

    const products = container.querySelectorAll("[data-product-item]");
    originalProductOrder = Array.from(products);
  }

  /**
   * Handle sort change from select dropdown
   */
  function handleSortChange(sortValue) {
    if (sortValue === "expired-date-asc" || sortValue === "expired-date-desc") {
      handleCustomSort(sortValue);
    } else if (isCustomSortActive) {
      // If switching back to a standard sort, let Shopify handle it normally
      isCustomSortActive = false;
      // Allow the default behavior to proceed
    }
  }

  /**
   * Handle custom sorting by expired date
   */
  function handleCustomSort(sortValue) {
    const container = document.querySelector("[data-productgrid-items]");
    if (!container) return;

    const products = Array.from(
      container.querySelectorAll("[data-product-item]"),
    );

    // Sort products based on expired date
    products.sort(function (a, b) {
      const dateA = a.getAttribute("data-expired-date");
      const dateB = b.getAttribute("data-expired-date");

      // Handle products without expired dates
      // Products without dates should go to the end
      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      const timestampA = new Date(dateA).getTime();
      const timestampB = new Date(dateB).getTime();

      if (sortValue === "expired-date-asc") {
        // Expiring Soon: closest to expiring first (ascending order)
        return timestampA - timestampB;
      } else {
        // Expiring Later: furthest from expiring first (descending order)
        return timestampB - timestampA;
      }
    });

    // Reorder DOM elements
    products.forEach(function (product) {
      container.appendChild(product);
    });

    isCustomSortActive = true;

    // Update URL without reloading page (for sharing purposes)
    updateURLParam("sort_by", sortValue);

    // Trigger any necessary re-initialization (e.g., lazy loading)
    triggerReInitialization();
  }

  /**
   * Update active button state in modal
   */
  function updateActiveButtonState(activeValue) {
    const allButtons = document.querySelectorAll(
      "[data-productgrid-trigger-sort-button]",
    );
    allButtons.forEach(function (button) {
      const buttonValue = button.getAttribute("value");
      if (buttonValue === activeValue) {
        button.classList.add("utils-sortby--modal-button--active");
        button.setAttribute("disabled", "disabled");
      } else {
        button.classList.remove("utils-sortby--modal-button--active");
        button.removeAttribute("disabled");
      }
    });
  }

  /**
   * Update URL parameter without page reload
   */
  function updateURLParam(key, value) {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.replaceState({}, "", url.toString());
  }

  /**
   * Trigger re-initialization for lazy loading and other features
   */
  function triggerReInitialization() {
    // Trigger lazy loading re-check
    if (typeof window.rimg !== "undefined" && window.rimg.refresh) {
      window.rimg.refresh();
    }

    // Trigger custom event for other scripts to listen to
    const event = new CustomEvent("expiredDateSortComplete", {
      detail: { sorted: true },
    });
    document.dispatchEvent(event);
  }

  /**
   * Check URL on page load for custom sort parameter
   */
  function checkURLForCustomSort() {
    const urlParams = new URLSearchParams(window.location.search);
    const sortBy = urlParams.get("sort_by");

    if (sortBy === "expired-date-asc" || sortBy === "expired-date-desc") {
      // Wait for DOM to be ready, then apply sort
      setTimeout(function () {
        handleCustomSort(sortBy);

        // Update select dropdown
        const sortSelect = document.querySelector(
          "[data-productgrid-trigger-sort]",
        );
        if (sortSelect) {
          sortSelect.value = sortBy;
        }

        updateActiveButtonState(sortBy);
      }, 100);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initExpiredDateSort();
      checkURLForCustomSort();
    });
  } else {
    initExpiredDateSort();
    checkURLForCustomSort();
  }

  // Re-initialize after AJAX content load (for infinite scroll or filters)
  document.addEventListener("shopify:section:load", function () {
    storeOriginalOrder();
    checkURLForCustomSort();
  });
})();
